export default __webpack_public_path__ + "static/media/revenue.7f9f2526.svg";